import forOwn from 'lodash/forOwn'
import includes from 'lodash/includes'
import isObject from 'lodash/isObject'

export function findObjectKeyDeep(obj: Record<any, any>, keyToFind: string): string {
  let foundPath = null

  const recurse = (recuseObj: any, parentKey?: string) => {
    forOwn(recuseObj, (value, key) => {
      const path = parentKey ? `${parentKey}.${key}` : key
      if (includes(key, keyToFind)) {
        //add to the set the found key
        foundPath = path
        return path
      } else if (isObject(value)) {
        return recurse(value, path)
      }
    })
  }

  //call the function
  recurse(obj)

  return foundPath
}
